import apiClient from './apiClient'

export interface MyProfile {
  id: number | null
  firstName?: string
  lastName?: string
  fullName: string
  // Pracovní kontakt
  email: string | null
  phone: string | null
  // Soukromý kontakt (editovatelné zaměstnancem)
  personalEmail: string | null
  personalPhone: string | null
  // Osoba blízká
  nextOfKinName: string | null
  nextOfKinAddress: string | null
  nextOfKinEmail: string | null
  nextOfKinPhone: string | null
  // Zařazení
  departmentName: string | null
  positionName: string | null
  managerFullName: string | null
  costCenter: string | null
  personalNumber: string | null
  hasMealVouchers: boolean
  // Pracovní
  employmentType: number
  status: number
  statusFrom: string | null
  hireDate: string
  cooperationStartDate: string | null
  terminationDate: string | null
  contractType: number
  contractEndDate: string | null
  probationEndDate: string | null
  // Rozvrh
  workingRatioPercent: number
  weeklyHours: number
  workScheduleJson: string | null
  // Osobní / soukromé (read-only pro zaměstnance)
  birthDate: string | null
  personalId: string | null
  healthInsurance: string | null
  healthInsuranceCode: string | null
  // Adresa
  address: string | null
  city: string | null
  postalCode: string | null
  country: string | null
  // Banka
  bankAccount: string | null
  // Vozidlo
  vehicle: string | null
  // Děti
  child1Name: string | null
  child1PersonalId: string | null
  child1Studies: boolean
  child2Name: string | null
  child2PersonalId: string | null
  child2Studies: boolean
  child3Name: string | null
  child3PersonalId: string | null
  child3Studies: boolean
  child4Name: string | null
  child4PersonalId: string | null
  child4Studies: boolean
  child5Name: string | null
  child5PersonalId: string | null
  child5Studies: boolean
  // Ostatní
  note: string | null
  entraObjectId: string | null
  personType: 'employee' | 'contractor'
  contractorId: number | null
  // Contractor-specific pole (pouze pro personType === 'contractor')
  companyName?: string | null
  ico?: string | null
  isVatPayer?: boolean
  expectedActivities?: string | null
  // Druhá aktivní role (když je člověk současně zaměstnanec i externista) — přepínač rolí
  otherRole?: MyProfile | null
}

export interface UpdateMyPrivateDataRequest {
  personalEmail?: string
  personalPhone?: string
  nextOfKinName?: string
  nextOfKinAddress?: string
  nextOfKinEmail?: string
  nextOfKinPhone?: string
}

export interface MyPensionContribution {
  id: number
  pensionProvider: string
  amount: number
  frequency: number
  contributionType: number
  validFrom: string | null
  validTo: string | null
}

export const meService = {
  getMe: () => apiClient.get<MyProfile>('/me').then(r => r.data),

  updatePrivate: (data: UpdateMyPrivateDataRequest) =>
    apiClient.put('/me/private', data),

  getMyPension: () =>
    apiClient.get<MyPensionContribution>('/me/pension').then(r => r.data),
}
